exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Clients{background-color:#eee;padding:60px 0;text-align:center}.Clients .container ul{flex-basis:100%;display:flex;flex-wrap:wrap;align-items:center;justify-content:center}.Clients .container ul li{flex-basis:20%;list-style:none;justify-content:center;align-items:center;margin:15px 0}@media (max-width:1024px){.Clients .container ul{width:90%;margin:0 auto}.Clients .container ul li{flex-basis:25%}}@media (max-width:768px){.Clients .container ul{width:90%;margin:0 auto}.Clients .container ul li{flex-basis:33.33333%}}@media (max-width:640px){.Clients .container ul{width:90%;margin:0 auto}.Clients .container ul li{flex-basis:50%}}@media (max-width:480px){.Clients .container ul li{flex-basis:50%}}@media (max-width:360px){.Clients .container ul li{flex-basis:100%;margin-bottom:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c86e8f0","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Clients.vue
// module id = 86
// module chunks = 0